import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import router from '@/router';
import store from '@/store/index'; // 固定菜单与路由

import { menuAside, menuHeader } from '@/menu';
import { frameInRoutes } from '@/router/routes';
import layoutHeaderAside from '@/layout/header-aside';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 将数据存储到指定位置 | 路径不存在会自动初始化
     * @description 效果类似于取值 dbName.path = value
     * @param {Object} 
     * @param {Object} 
     * @param {Object} 
     * @param {Object} 
     * @param {Object} 
     */
    addRouter: function addRouter(_ref, list) {
      var dispatch = _ref.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
          var permissionMenu, permissionRouter, formatRoutes, accessMenus, allMenuAside, allMenuHeader;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  permissionRouter = [];

                  formatRoutes = function formatRoutes(routes) {
                    routes.forEach(function (route) {
                      route.component = route.auth_path == "" ? layoutHeaderAside : function (resolve) {
                        return require(["@/views".concat(route.auth_path)], resolve);
                      };
                      route.path = route.auth_path;
                      var paths = route.auth_path ? route.auth_path.split('/') : null;
                      route.name = paths ? paths[paths.length - 1] : '';
                      route.meta = {
                        title: route.auth_name,
                        cache: true
                      };
                      route.children = route.Children || [];

                      if (route.Children.length) {
                        formatRoutes(route.Children);
                      }
                    });
                  };

                  _context.next = 4;
                  return store.dispatch('d2admin/permission/generateAccessMenus', permissionRouter);

                case 4:
                  accessMenus = _context.sent;
                  //组合代码生成器生成的菜单和路由
                  permissionMenu = _toConsumableArray(accessMenus);
                  permissionRouter = _toConsumableArray(list);
                  allMenuAside = [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenus));
                  allMenuHeader = [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenus));
                  formatRoutes(list); //动态添加路由

                  router.addRoutes(list); // 处理路由 得到每一级的路由设置

                  store.commit('d2admin/page/init', [].concat(_toConsumableArray(frameInRoutes), _toConsumableArray(permissionRouter))); // 设置顶栏菜单

                  store.commit('d2admin/menu/headerSet', allMenuHeader); // 设置侧边栏菜单

                  store.commit('d2admin/menu/asideSet', allMenuAside); // 初始化菜单搜索功能

                  store.commit('d2admin/search/init', allMenuHeader); // 加载上次退出时的多页列表

                  store.dispatch('d2admin/page/openedLoad');
                  resolve();

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }
};